import React, {useState, useLayoutEffect} from 'react';
import {connect} from "react-redux";
import {dropDownPosition, toLocalDateTime} from "../../../../../../../../../../../../../utils";
import MoreOptions from './components/more-options';
import {
    deleteComment, editingComment,
    isLoadingCommentToDelete
} from "../../../../../../../../../../../../../../actions/commentActions";

function CommentHeader (props) {

    const {
        authorName,
        profile,
        timestamp,
	    updatedTimestamp,
        commentId,
        sharingDetailsPopup,
        selectedContactsGroup,
        setEditingComment,
        setIsLoadingCommentToDelete,
        deleteComment,
        contactDetails,
        aiComment
    } = props;

    const [extendDropDown, setExtendDropDown] = useState(false);
    const [target, setTarget] = useState(null);

    useLayoutEffect(() => {
        if(target !== null && extendDropDown){
            dropDownPosition(
                target.parentElement,
                target,
                target.children[1]
            );
        }
    }, [extendDropDown, target]);

    const clickHandler = (e) => {
        setTarget(e.currentTarget);
        setExtendDropDown(!extendDropDown);
    };

    const mouseLeaveHandler = () => {
        setTarget(null);
        setExtendDropDown(null);
    };

    const editCommentHandler = () => {
        setEditingComment(commentId)
    };

    const deleteCommentHandler = () => {
        setIsLoadingCommentToDelete(true);
        if(sharingDetailsPopup.length > 0) {
            deleteComment(sharingDetailsPopup[2][0].id, commentId, selectedContactsGroup.id);
        } else {
            deleteComment(contactDetails.id, commentId, selectedContactsGroup.id);
        }
    };

    return (
        <div className="d-flex justify-content-between" onMouseLeave={mouseLeaveHandler}>
            <p className="mb-1">
                <strong>{authorName}</strong>
                {
                    aiComment && <span className="ml-1 align-text-bottom">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="20px"
                            height="20px"
                            viewBox="0 0 20 20"
                            enableBackground="new 0 0 20 20"
                            xmlSpace="preserve"
                        >
                            <path
                                d="M20,10c-8.571,0.789-9.211,1.429-10,10c-0.789-8.571-1.429-9.211-10-10C8.571,9.211,9.211,8.571,10,0 C10.789,8.571,11.429,9.211,20,10z"/>
                            <path
                                d="M20,3.5C17,3.776,16.776,4,16.5,7C16.224,4,16,3.776,13,3.5C16,3.224,16.224,3,16.5,0C16.776,3,17,3.224,20,3.5z"/>
                            <path
                                d="M0,16.5C3,16.224,3.224,16,3.5,13C3.776,16,4,16.224,7,16.5C4,16.776,3.776,17,3.5,20C3.224,17,3,16.776,0,16.5z"/>
                        </svg>
                    </span>
                }
                {
                    updatedTimestamp && <em className="small ml-1" title={updatedTimestamp}>- Updated</em>
                }
            </p>
            <p className="comment-date mb-1">
                {toLocalDateTime(timestamp)}
            </p>
            {
                authorName === profile.name && selectedContactsGroup.permission !== 'READ_ONLY'
                    ?
                    <MoreOptions
                        target={target}
                        extendDropDown={extendDropDown}
                        commentId={commentId}
                        clickHandler={clickHandler}
                        mouseLeaveHandler={mouseLeaveHandler}
                        editCommentHandler={editCommentHandler}
                        deleteCommentHandler={deleteCommentHandler}
                    />
                    :
                    null
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    profile: state.profileReducer.getProfile,
    sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
    selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
    contactDetails: state.contactDetailsReducer.findContactDetails
});

const mapDispatchToProps = (dispatch) => ({
    deleteComment: (contactId, commentId, labelId) => dispatch(deleteComment(contactId, commentId, labelId)),
    setIsLoadingCommentToDelete: (boolean) => dispatch(isLoadingCommentToDelete(boolean)),
    setEditingComment: (string) => dispatch(editingComment(string)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentHeader);
